<template>
    <div class="special">
        <div class="name">
            <div class="title">{{title}}</div>
            <div class="downTime">
                <span><i>距结束</i></span>
                <span><vantCountDown :time="presellData.countdown" :millisecond="false" @onCountDown="onCountDown" /></span>
            </div>
        </div>
        <div class="more" @click="onMore">
            <span class="tip">更多</span><span class="icon"></span>
        </div>
    </div>
</template>

<script>
import vantCountDown from '../../../common/homeCountDown'
export default {
    components: {
        vantCountDown
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        presellData: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    methods: {
        onCountDown () {
            this.$parent.$parent.presellCountDown()
        },
        onMore () {
            this.$emit('onMore')
        }
    }
}
</script>

<style lang="scss" scoped>
    .special {
        width: 100%;
        font-size: 34px;
        color: #ff4d4f;
        height: 48px;
        line-height: 48px;
        display: flex;
        justify-content: space-between;
        .name{
            flex: 1;
            display: flex;
            align-self: start;
            align-items: center;
        }
        .title {
            line-height: 48px;
            font-weight: bold;
            color: #1A1A1A;
            margin-right: 20px;
        }
        .downTime{
            position: relative;
            font-size: 20px;
            font-weight: 500;
            height: 36px;
            line-height: 36px;
            border: 2px solid #FF571F;
            border-radius: 36px;
            display: flex;
            box-sizing: border-box;
            span{
                // display: inline-block;
                // height: 34px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: center;
                // transform: scale(0.92);
                &:first-child{
                    width: 96px;
                    position: absolute;
                    top: -2px;
                    left: -2px;
                    background: #FF571F;
                    border-radius: 34px;
                    color: #ffffff;
                    text-align: center;
                }
                &:last-child{
                    padding: 0 12px 0 108px;
                    font-size: 24px;
                }
                i{
                    display: inline-block;
                }
            }
        }
        .more {
            font-size: 26px;
            line-height: 36px;
            color: #888888;
            display: flex;
            align-items: center;
            .icon {
                width: 40px;
                height: 40px;
                background: url(../../../../../assets/img/b2b/img_arrow_next@2x.png)
                        no-repeat;
                background-size: cover;
            }
        }
        .count .inProgress{
            font-size: 24px !important;
        }
    }
</style>